import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) return;
    setLoading(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch {
      setError('E-posta veya şifre hatalı. Tekrar dene.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.bg1} />
      <div style={styles.bg2} />
      <div style={styles.content}>
        <div style={styles.iconWrap}>
          <img src="/logo192.png" alt="" style={styles.appIcon} />
        </div>
        <h1 style={styles.title}>Serhat & Ayça</h1>
        <p style={styles.sub}>Sadece ikimize özel</p>

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>E-posta</label>
            <input
              type="email"
              placeholder="email@gmail.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoComplete="email"
              inputMode="email"
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Şifre</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ marginTop: 8 }}
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>

      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    position: 'relative',
    overflow: 'hidden',
    background: '#080810',
  },
  bg1: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(180deg, rgba(124,58,237,0.2) 0%, transparent 42%)',
    pointerEvents: 'none',
  },
  bg2: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(135deg, transparent 20%, rgba(6,182,212,0.08) 52%, transparent 78%)',
    pointerEvents: 'none',
  },
  content: {
    width: '100%',
    maxWidth: 380,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    position: 'relative',
    zIndex: 1,
  },
  iconWrap: {
    width: 84,
    height: 84,
    borderRadius: 24,
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 14,
    boxShadow: '0 20px 70px rgba(79,70,229,0.28)',
    overflow: 'hidden',
  },
  appIcon: { width: '100%', height: '100%', objectFit: 'cover' },
  title: {
    fontFamily: "'Inter', sans-serif",
    fontSize: 34,
    fontWeight: 850,
    letterSpacing: '-0.02em',
    background: 'linear-gradient(135deg, #ffffff, #A78BFA)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textAlign: 'center',
  },
  sub: {
    color: 'rgba(255,255,255,0.56)',
    fontSize: 14,
    fontWeight: 300,
    marginBottom: 20,
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    padding: 16,
    borderRadius: 24,
    border: '1px solid rgba(255,255,255,0.085)',
    background: 'rgba(255,255,255,0.045)',
    backdropFilter: 'blur(18px)',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  label: {
    fontSize: 13,
    color: 'rgba(255,255,255,0.56)',
    fontWeight: 650,
    paddingLeft: 4,
  },
  error: {
    color: '#FCA5A5',
    fontSize: 13,
    textAlign: 'center',
    padding: '8px 12px',
    background: 'rgba(239,68,68,0.1)',
    border: '1px solid rgba(239,68,68,0.16)',
    borderRadius: 14,
  },
};
